import '@ricoh/ria.client.core/styles';

import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import DialogNetwork from '@ricoh/ria.client.core/components/dialog/network';
import Toast from '@ricoh/ria.client.core/components/popup/toast';
import I18nProvider from '@ricoh/ria.client.core/plugins/i18n/provider';
import KendoProvider from '@ricoh/ria.client.core/plugins/kendo';
import RsuiteProvider from '@ricoh/ria.client.core/plugins/rsuite';
import SwrProvider from '@ricoh/ria.client.core/plugins/swr/provider';

import { authMiddleware } from '~/plugins/auth';
import AppRouterProvider from '~/plugins/router';
import StoreProvider from '~/plugins/store/provider';
import SessionTimeout from '~/components/feature/auth/session-timeout';

import type { AppProps, AppRef } from './_.type';

import useAppHooks from './_.hook';

/** ApplicationRoot. */
export default memo(
  forwardRef(function ApplicationRoot(props: AppProps, ref: ForwardedRef<AppRef>): ReactNode {
    const { reloadDocument } = props;

    useAppHooks(props, ref);

    return (
      <StoreProvider>
        <SwrProvider middlewares={[authMiddleware]}>
          <I18nProvider>
            <RsuiteProvider>
              <KendoProvider>
                <AppRouterProvider reloadDocument={reloadDocument} />
                <Toast />
                <SessionTimeout />
                <DialogNetwork />
              </KendoProvider>
            </RsuiteProvider>
          </I18nProvider>
        </SwrProvider>
      </StoreProvider>
    );
  }),
);
